/* eslint-disable import/prefer-default-export */
import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { getCostDetails } from "api/services/quotation";
import { quotationQueryKeys } from "./quotationQueryKeys";

export const useGetCostDetails = (id: string, options: UseQueryOptions) =>
  useQuery<any>({
    queryKey: quotationQueryKeys.costDetails(id),
    queryFn: () => getCostDetails(id).then((res) => res.data),
    ...options,
  });
